import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../enums/local-storage-keys.enum';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    get privacyPolicyAccepted(): boolean {
        return localStorage.getItem(LocalStorageKeys.PrivacyPolicy) === 'true';
    }

    set privacyPolicyAccepted(value: boolean) {
        localStorage.setItem(LocalStorageKeys.PrivacyPolicy, value.toString());
    }
}
